import { create } from 'zustand';
import { Category } from '../data/Category';

type CategoryDrawerStore = {
    isOpen: boolean,
    isEdit: boolean,
    data: Category | undefined,
    openNew: () => void,
    openEdit: (category: Category) => void,
    close: () => void,
}

export const useCategoryDrawerStore = create<CategoryDrawerStore>((set) => ({
    isOpen: false,
    isEdit: false,
    data: undefined,
    openNew: () => set(() => ({ isOpen: true, isEdit: false, data: undefined })),
    openEdit: (category: Category) => set(() => ({ isOpen: true, isEdit: true, data: category })),
    close: () => set(() => ({ isOpen: false, data: undefined })),
}))